import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "../../../../../../../components/MessageWithLink/types";

export enum TaxableBenefits {
  CAR = "Car",
  CHILDCARE = "Childcare",
  COMMUTER_ALLOWANCE = "Commuter Allowance",
  LIVING_ACCOMMODATIONS = "Living Accommodations",
  MEAL_ALLOWANCE = "Meal Allowance",
  MEDICAL_INSURANCE = "Medical Insurance",
  NON_CASH_GIFTS_AND_AWARDS = "Non-Cash Gifts & Awards",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational Facilities & Dues",
  REMOTE_WORK = "Remote Work",
  VACATION_SERVICES = "Vacation Services",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.MEDICAL_INSURANCE]: {
    text: "Tax-exempt up to €400 per year.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.NON_CASH_GIFTS_AND_AWARDS]: {
    text: "Tax-exempt up to 300 RON per occasion.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.RECREATIONAL_FACILITIES_AND_DUES]: {
    text: "Tax-exempt up to €100 per year.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.REMOTE_WORK]: {
    text: "Tax-exempt up to 400 RON per year.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
